import * as React from 'react'
import * as domain from '@packages/domain'
import styled, { css } from 'styled-components'
import { b, O, pipe, RA } from '@packages/prelude'
import { CategoryTitle } from '../components/CategoryTitle'
import { react, date } from '../commons'
import { PostImage } from '../components/PostImage'
import { BasePost } from './BasePost'

export interface EventProps {
  post: domain.Event.Type
}
const Description = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const EventDatesWrapper = styled.p`
  font-size: var(--bs-h4-font-size);
  color: var(--bs-primary);
  font-style: italic;
  font-weight: 700;
  text-transform: uppercase;
`

const Cancelled = css`
  text-decoration: line-through;
  text-decoration-thickness: 2px;
  color: var(--bs-gray-600);
`

const EventDate = styled.span<{ cancelled: boolean }>`
  ${props => props.cancelled && Cancelled}
`
const DateDivider = styled.span`
  padding: 0 0.5rem;
`

const Badge = styled.span`
  position: absolute;
  left: 0.5rem;
  bottom: 0.5rem;
  z-index: 10;
  display: inline-block;
  padding: 0 1.5rem;

  font-family: var(--bs-font-family-sans-serif);
  font-weight: 700;
  font-style: italic;
  font-size: 1.2rem;

  color: var(--bs-white);
  background-color: #ffd800;
`

const EventImage: React.VFC<domain.Event.Type> = ({ ...event }) => (
  <PostImage {...event}>
    {pipe(
      event.eventDates,
      RA.exists(({ cancelled, changed }) => cancelled || changed),
      b.fold(
        () => react.monoid.empty,
        () => <Badge>Änderungen!</Badge>
      )
    )}
  </PostImage>
)

export const Event: React.VFC<EventProps> = ({ post }) => {
  return (
    <BasePost
      post={post}
      title={<CategoryTitle name={'Termin'} icon={'fa-solid fa-calendar-days'} />}
      image={<EventImage {...post}></EventImage>}>
      <EventDatesWrapper>
        {pipe(
          post.eventDates,
          RA.filter(({ dateStart }) => O.isSome(dateStart)),
          RA.map(eventDate =>
            pipe(
              eventDate.dateStart,
              O.map(date.format({ day: '2-digit', month: 'short', year: 'numeric' })),
              O.foldMap(react.monoid)(dateStart => (
                <EventDate key={dateStart} cancelled={eventDate.cancelled}>
                  {dateStart}
                </EventDate>
              ))
            )
          ),
          RA.intercalate(react.monoid)(<DateDivider>|</DateDivider>)
        )}
      </EventDatesWrapper>
      <Description dangerouslySetInnerHTML={{ __html: post.description }} />
    </BasePost>
  )
}
